export default __webpack_public_path__ + "static/media/waste-water.65f1071e.jpg";